export default __webpack_public_path__ + "static/media/fondo3.587b2000.jpg";